export const produtoNacionalBMPEnum = {
    eficienciaEnergetica: 870,
    manufaturaEnxuta: 869,
    smartFactoryPiloto: 873,
    smartFactory: 874,
    transformacaoFase1Piloto: 871,
    transformacaoFase2Piloto: 875,
    transformacaoImplementacaoContinuacao: 891,
    transformacaoImplementacaoContratacaoDireta: 892,
    transformacaoImplementacaoSiriContratacaoDireta: 893,
    consultoriaTransformacaoImplementacao: 894,
    consultoriaTransformacaoSiriDigitalizacao: 895,
    consultoriaTransformacaoSiri: 896,
};